/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubsidiariesTotalsDto } from './SubsidiariesTotalsDto';
import {
    SubsidiariesTotalsDtoFromJSON,
    SubsidiariesTotalsDtoFromJSONTyped,
    SubsidiariesTotalsDtoToJSON,
    SubsidiariesTotalsDtoToJSONTyped,
} from './SubsidiariesTotalsDto';
import type { LegalEntityFinancialsDto } from './LegalEntityFinancialsDto';
import {
    LegalEntityFinancialsDtoFromJSON,
    LegalEntityFinancialsDtoFromJSONTyped,
    LegalEntityFinancialsDtoToJSON,
    LegalEntityFinancialsDtoToJSONTyped,
} from './LegalEntityFinancialsDto';
import type { SubsidiaryDto } from './SubsidiaryDto';
import {
    SubsidiaryDtoFromJSON,
    SubsidiaryDtoFromJSONTyped,
    SubsidiaryDtoToJSON,
    SubsidiaryDtoToJSONTyped,
} from './SubsidiaryDto';

/**
 * 
 * @export
 * @interface GetSubsidiariesResponse
 */
export interface GetSubsidiariesResponse {
    /**
     * Last fiscal year declared by the parent legal entity. Null when nothing has been declared.
     * @type {LegalEntityFinancialsDto}
     * @memberof GetSubsidiariesResponse
     */
    parentFinancials?: LegalEntityFinancialsDto | null;
    /**
     * 
     * @type {Array<SubsidiaryDto>}
     * @memberof GetSubsidiariesResponse
     */
    subsidiaries: Array<SubsidiaryDto>;
    /**
     * 
     * @type {SubsidiariesTotalsDto}
     * @memberof GetSubsidiariesResponse
     */
    totals: SubsidiariesTotalsDto;
}

/**
 * Check if a given object implements the GetSubsidiariesResponse interface.
 */
export function instanceOfGetSubsidiariesResponse(value: object): value is GetSubsidiariesResponse {
    if (!('subsidiaries' in value) || value['subsidiaries'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    return true;
}

export function GetSubsidiariesResponseFromJSON(json: any): GetSubsidiariesResponse {
    return GetSubsidiariesResponseFromJSONTyped(json, false);
}

export function GetSubsidiariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubsidiariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parentFinancials': json['parentFinancials'] == null ? undefined : LegalEntityFinancialsDtoFromJSON(json['parentFinancials']),
        'subsidiaries': ((json['subsidiaries'] as Array<any>).map(SubsidiaryDtoFromJSON)),
        'totals': SubsidiariesTotalsDtoFromJSON(json['totals']),
    };
}

export function GetSubsidiariesResponseToJSON(json: any): GetSubsidiariesResponse {
    return GetSubsidiariesResponseToJSONTyped(json, false);
}

export function GetSubsidiariesResponseToJSONTyped(value?: GetSubsidiariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentFinancials': LegalEntityFinancialsDtoToJSON(value['parentFinancials']),
        'subsidiaries': ((value['subsidiaries'] as Array<any>).map(SubsidiaryDtoToJSON)),
        'totals': SubsidiariesTotalsDtoToJSON(value['totals']),
    };
}

